// extracted by mini-css-extract-plugin
module.exports = {"table":"Activity_table__3xpnx","backButton":"Activity_backButton__1_GE1","link":"Activity_link__2kGhc","container":"Activity_container__3zRrl"};